import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';

const useStyles = makeStyles({
    list: {
        width: 500,
    },
    fullList: {
        width: 'auto',
    },

});

export default function QuoteDrawer({ row }) {
    // console.log('row', row)
    const classes = useStyles();
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor, row) => {
        /*  {
              created_at: "2020-12-17T20:56:00.000Z"
              ctiQuoteParent: { boxStatus: "good", packageDamaged: "false", receivedDate: null, estimatedDeliveryDate: null, trackingLink: null, … }
             'address1',
                        'address2',
                        'city',
                        'state',
                        'zip',
                        'country',
              customer: { customerName: "Ekrem company" }
              deviceId: "2T1BU4EE1BC199271"
              deviceProcessingState: { name: "billed" }
              id: 54
              inactive: 0
              item: { name: "#1 APPLE IPHONE 5 32GB WHITE OEM" }
              itemName: "It"
              originalDeviceId: "2T1BU4EE1BC199271"
              pcsNegotiatedValue: null
              rawData: null
              tradeInDate: "2020-12-17T05:00:00.000Z"
              updated_at: "2020-12-17T20:56:00.000Z"
              _contact: 10002
              _ctiQuoteParent: 64
              _customer: 2
              _deviceProcessingState: 3
              _item: 328
               originalDeviceId: quote.deviceId,
            originalManufacturer: quote.deviceManufacturer,
            originalModel: quote.deviceModel,
            originalStorage: quote.deviceStorage,
            originalCarrier: quote.deviceCarrier,
            originalColor: quote.deviceColor,
          }*/
        const dataToPrint = [
            // { label: 'device Type', value: row.item.name, icon: '' },
            { label: 'Trade In Date and Time', value: row.tradeInDate, icon: '' },
            { label: 'Device Manufacturer', value: row.originalManufacturer, icon: '' },
            { label: 'Device Model', value: row.originalModel, icon: '' },
            { label: 'Device Storage Capacity', value: row.originalStorage, icon: '' },
            { label: 'Device Carrier', value: row.originalCarrier, icon: '' },
            { label: 'Device Color', value: row.originalColor, icon: '' },
            // { label: 'Carrier Name', value: row.ctiQuoteParent.name, icon: '' },
            // { label: 'Carrier Service Level', value: '', icon: '' },
            { label: 'Name', value: row.ctiQuoteParent.name, icon: '' },
            {
                label: 'Ship Address', value: `
            ${row.ctiQuoteParent.address1} 
            ${row.ctiQuoteParent?.address2 || ''}
            ${row.ctiQuoteParent.city}, ${row.ctiQuoteParent.state} ${row.ctiQuoteParent.zip}            
            `, icon: ''
            },
            // { label: 'device Type', value: '', icon: '' },
            { label: 'IMEI/SN', value: row.originalDeviceId, icon: '' },
            { label: 'Phone #', value: row.ctiQuoteParent.phone, icon: '' },
            { label: 'Purchase Order', value: row.purchaseOrder, icon: '' }
        ]

        return <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === 'top' || anchor === 'bottom',
            })}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <h1>Trade In Details</h1>
            {/* <List>
                <ListItem  >
                    <ListItemText primary='Trade In Details' />
                </ListItem>
            </List> */}

            <Divider />
            <List>
                {dataToPrint.map(({ label, value }, index) => (
                    <ListItem key={index} >
                        {/* <ListItemIcon><MailIcon /></ListItemIcon> */}
                        <ListItemText primary={label} />
                        <ListItemText primary={<>{value}</>} />
                    </ListItem>
                ))}
            </List>
        </div>
    };

    return (
        <div>
            <React.Fragment key={'right'}>
                <Button
                    color="primary"
                    variant="outlined"
                    onClick={toggleDrawer('right', true)}>{'Trade In Details'}
                </Button>
                <Drawer anchor={'right'} open={state['right']}

                    PaperProps={{
                        width: '950'
                    }}
                    onClose={toggleDrawer('right', false)}>
                    {list('right', row)}
                </Drawer>
            </React.Fragment>
        </div>
    );
}
